import {
  type ApiResponse,
  idempotencyHeader
} from '../../api-client';

import {
  apiRequest
} from './client';

// Deliberately separate from pricing.service.ts - this hits the public,
// reCAPTCHA-gated checkout endpoint (no Bearer auth), not the authenticated
// admin pricing CRUD. A direct package purchase: pick a package, provide
// details, pay - no enquiry involved.

export interface PackageCheckoutInput {
  clientEmail: string
  clientFirstName: string
  clientLastName: string
  clientPhoneNumber: string
  referralCode?: string
  trackingSessionId?: string
  recaptchaToken: string
  // per_university packages: which universities (billing prices each one).
  institutionIds?: number[]
  // per_application packages: how many applications.
  quantity?: number
  // Extras bought with this package: residence (per university, only at a
  // university being applied to) and bursary (a count). Billing prices them.
  addOns?: CheckoutAddOn[]
}

export interface CheckoutAddOn {
  packageKey: string
  institutionIds?: number[]
  quantity?: number
}

export interface PackageCheckoutResult {
  quoteId: number
  invoiceId: number
  paymentUrl: string
  totalCents: number
}

export async function checkoutPackage(
  packageId: number,
  input: PackageCheckoutInput,
  idempotencyKey?: string
): Promise<ApiResponse<PackageCheckoutResult>> {

  return apiRequest<ApiResponse<PackageCheckoutResult>>(
    `/pricing/application-packages/${ packageId }/checkout`,
    {
      method: 'POST',
      body: JSON.stringify(input),
      headers: idempotencyHeader(idempotencyKey)
    }
  );
}
